import { Component, input, output } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'boels-order-entry-product-quantity',
  imports: [FormsModule, TranslocoModule, ReactiveFormsModule, FaIconComponent],
  templateUrl: './order-entry-product-quantity.component.html',
  styleUrl: './order-entry-product-quantity.component.scss',
})
export class OrderEntryProductQuantityComponent {
  protected readonly faPencil = faPencil;
  value = input.required<number>();
  event = output<string>();
}
